import { Button } from "@/components/ui/button";

/** Shown when the overview could not be loaded at all: what went wrong plus a way to try again. */
const LoadErrorNotice = ({ message, onRetry }: { message: string | null; onRetry: () => void }) => (
  <div role="alert" className="space-y-2 text-sm">
    <p className="text-destructive">Couldn't load model status: {message}</p>
    <Button size="sm" variant="outline" onClick={onRetry}>
      Retry
    </Button>
  </div>
);

export default LoadErrorNotice;
